import { theme } from '@noths/polaris-client-ribbons-base';
import { pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { colors, fonts, spacing } = theme;

export const wrapper = css`
  margin: ${pxToRem(spacing.xxxl)} ${pxToRem(spacing.sm)};
`;

export const heading = css`
  text-align: center;
`;

export const subheading = css`
  margin-bottom: 4rem;
  text-align: center;
`;

export const cta = css`
  width: 12rem;
  margin: 0 auto;
  display: block;
  text-align: center;
  color: ${colors.neutralDarker};
  font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
`;
